<template>
	<transition>
		<slot></slot>
	</transition>
</template>

<script>
export default {
	name: 'SlideDown'
}
</script>

<style scoped>
.v-enter-active, .v-leave-active {
	transition: all 3s ease;
}

.v-enter {
	transform: translateY(1000px);
}
.v-leave-to {
	transform: translateY(1000px);
}
</style>